export default __webpack_public_path__ + "static/media/icon_information_circle_15_Regular_grey.46b871fd.svg";